import React, { FC, useState, useEffect, useCallback } from "react";
import CommonForm from "./CommonForm";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import EditIcon from "../../static/images/Editicon.svg";
import DeleteIcon from "../../static/images/Archive.svg";
import axios from "../../../config/axios";
import Spinner from "../atoms/Spinner";
import validator from "validator";
import { format, parseISO } from "date-fns";

import GenericFields from "./GenericFields";
import { service } from "../../../services/AxiosServices";
import SectionHeader from "./SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";
import ConfirmDialog from "../atoms/ConfirmDialog";
import AccessControl from "./AccessControl";
import AccessDenied from "../atoms/AccessDenied";
import useAccessCheckLoading from "../../../utils/useAccessCheckLoading";
interface CrewDetails {
  crew_name: string;
  id: string;
}
interface ToolOption {
  name: string;
  value: string;
}
interface Props {
  crewName?: string;
  agentId?: string;
}

interface CrewOption {
  name: string;
  value: string;
}
type Field = {
  name: string;
  type: string;
};
//Agent form
const AgentForm: FC<Props> = ({ crewName, agentId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const agentDetail = location.pathname.includes("agent_detail");
  const { id } = useParams<{ id: string }>();
  const crewId = Number(id);
  const [crewname, setCrewname] = useState("");
  const [crewDataLoaded, setCrewDataLoaded] = useState(false);
  const [crewDetails, setCrewDetails] = useState<CrewDetails[]>([]);
  const [toolsDetails, setToolsDetails] = useState<ToolOption[]>([]);
  const isEdit = Boolean(agentId);
  const [loading, setLoading] = useState<boolean>(false);
  const [showKeywordField, setShowKeywordField] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const accessCheckLoading = useAccessCheckLoading()
  const [formState, setFormState] = useState({
    values: {
      CrewName: "",
      AgentName: "",
      Role: "",
      Tool: "",
      LLMs: "",
      Goal: "",
      Backstory: "",
      IMAPServer: "",
      SMTPServer: "",
      FromEmail: "",
      RecipientEmailAddress: "",
      EmailPassword: "",
      PostAPI: "",
      endPoint: "",
      authType: "",
      authToken: "",
      method: "",
      inputType: "",
      fields: "",
      header: "",
      username: "",
      password: "",
      project: "",
      bucketName: "",
      awsAccessKey: "",
      awsSecretKey: "",
      regionName: "",
      // jd:'',
      finetune: false,
      knowledgeHub: false,
      keyword: "",
      updatedAt: "",
      createdAt: "",
    },
    clientErrors: {} as Record<string, string>,
    serverError: null as string | null,
  });

  useEffect(() => {
    const singleCrew = async () => {
      try {
        setLoading(true);
        const response = await service<any>("/api/get-all-crew", "post", {
          project_id: localStorage.getItem("project_id"),
        });
        const formattedData = response.data.crews.find(
          (ele: any) => ele.id == id
        )?.crew_name;
        if (formattedData) {
          setCrewname(formattedData);
          setFormState((prev) => ({
            ...prev,
            values: {
              ...prev.values,
              CrewName: formattedData,
            },
          }));
        }
      } catch (err) {
        console.error("Error fetching crew name:", err);
      } finally {
        setCrewDataLoaded(true);
        setLoading(false);
      }
    };
    singleCrew();
  }, [id]);

  useEffect(() => {
    if (!crewDataLoaded) return;

    const listCrews = async () => {
      setLoading(true);
      try {
        const response = await service<Record<string, any>>(
          "api/get-all-crew",
          "post",
          { project_id: localStorage.getItem("project_id") }
        );

        const sortedCrews = (response.data.crews || []).sort(
          (a: CrewDetails, b: CrewDetails) =>
            a.crew_name.localeCompare(b.crew_name)
        );
        setCrewDetails(sortedCrews);
      } catch (err) {
        console.error("Error fetching crews:", err);
      } finally {
        setLoading(false);
      }
    };

    const listTools = async () => {
      setLoading(true);
      try {
        const response = await service<ToolOption[]>(
          "/api/tool-choices/",
          "get"
        );
        setToolsDetails(response.data);
      } catch (err) {
        console.error("Error fetching tools:", err);
      } finally {
        setLoading(false);
      }
    };

    if (isEdit) {
      const fetchAgentDetails = async () => {
        setLoading(true);
        try {
          const response = await service<Record<string, any>>(
            "/api/get-agent/",
            "post",
            {
              agent_id: agentId,
              project_id: localStorage.getItem("project_id"),
            }
          );

          const agentData = response.data.agent;
          const toolsData = agentData.tools || {};
          const toolValue = toolsData.tools?.toString() || "";
          const apiData = toolsData.api_data || {};
          const fieldsData = apiData.fields || [];
          const headerData = apiData.headers || {};
          const headerString = Object.entries(headerData)
            .map(([key, value]) => `${key}:${value}`)
            .join(",");

          setShowKeywordField(agentData.knowledge_hub || false);
          setFormState((prev) => ({
            ...prev,
            values: {
              ...prev.values,
              CrewName: crewname || "",
              AgentName: agentData.agent_name || "",
              Role: agentData.function || "",
              Goal: agentData.goal || "",
              Backstory: agentData.backstory || "",
              finetune: agentData?.finetune || false,
              Tool: toolValue,
              IMAPServer: toolsData.imap_server || "",
              SMTPServer: toolsData.smtp_server || "",
              FromEmail: toolsData.from_email || "",
              RecipientEmailAddress: toolsData.to_email || "",
              EmailPassword: toolsData.password || "",
              endPoint: apiData.end_point || "",
              authType: apiData.auth_type || "",
              authToken: apiData.auth_token || "",
              method: apiData.method || "",
              inputType: apiData.input_type || "RAW",
              fields: fieldsData
                .map(
                  (field: any) => `${field.name}:${field.type}:${field.default}`
                )
                .join(","),
              header: headerString,
              project: apiData.project || "",
              username: apiData.username || "",
              password: apiData.password || "",
              bucketName: toolsData?.s3_details?.bucket_name || "",
              regionName: toolsData?.s3_details?.region_name || "",
              awsAccessKey: toolsData?.s3_details?.aws_access_key || "",
              awsSecretKey: toolsData?.s3_details?.aws_secret_key || "",
              knowledgeHub: agentData?.knowledge_hub || false,
              keyword: agentData?.knowledge_keyword || "",
              updatedAt: format(
                parseISO(agentData.updated_at),
                "dd-MM-yyyy, HH:mm"
              ),
              createdAt: format(
                parseISO(agentData.created_at),
                "dd-MM-yyyy, HH:mm"
              ),
            },
          }));
        } catch (err) {
          console.error("Error fetching agent data:", err);
          setFormState((prev) => ({
            ...prev,
            serverError: "Failed to fetch agent data. Please try again.",
          }));
        } finally {
          setLoading(false);
        }
      };

      Promise.all([fetchAgentDetails(), listCrews(), listTools()]);
    } else {
      Promise.all([listCrews(), listTools()]);
    }
  }, [crewDataLoaded, isEdit, agentId, crewName]);

  const crews: CrewOption[] = [
    { name: "Select a crew", value: "" },
    ...crewDetails.map((crew) => ({
      name: crew.crew_name,
      value: crew.id,
    })),
  ];

  const tools: ToolOption[] = [
    { name: "Select", value: "" },
    ...toolsDetails
      .map((tool: any) => ({
        name: tool.label,
        value: tool.id,
      }))
      .sort((a: any, b: any) => a.name.localeCompare(b.name)),
  ];
  const authTypes: any[] = [
    { name: "Select", value: "" },
    { name: "No Auth", value: "no_auth" },
    { name: "Bearer token", value: "bearer_token" },
    { name: "Basic Auth", value: "basic_auth" },
  ];
  const sortedAuthTypes: any[] = [
    authTypes[0],
    ...authTypes.slice(1).sort((a, b) => a.name.localeCompare(b.name)),
  ];

  const LLMs: CrewOption[] = [
    { name: "Select", value: "" },
    { name: "GPT-4", value: "GPT-4" },
    { name: "GPT-3.5", value: "GPT-3.5" },
    { name: "Claude 3.5 sonnet", value: "Claude 3.5 sonnet" },
    { name: "LLaMA 2", value: "LLaMA 2" },
  ];
  const sortedLLMs: CrewOption[] = [
    LLMs[1],
    ...LLMs.slice(1).sort((a, b) => a.name.localeCompare(b.name)),
  ];
  const methods = [
    { name: "Select", value: "" },
    { name: "POST", value: "POST" },
    { name: "GET", value: "GET" },
    { name: "PUT", value: "PUT" },
    { name: "DELETE", value: "DELETE" },
  ];
  const fields = [
    {
      name: "CrewName",
      type: crewId === 0 ? "select" : "text",
      label: "Crew name",
      options: crewId === 0 ? crews : undefined,
      disabled: crewId !== 0,
      required: true,
    },

    { name: "AgentName", type: "text", label: "Agent name", required: true },
    { name: "Role", type: "text", label: "Role", required: true },
    {
      name: "finetune",
      type: "checkbox",
      label: "Finetuneable agent",
    },
    {
      name: "knowledgeHub",
      type: "checkbox",
      label: "Knowledge hub",
    },
    ...(showKeywordField
      ? [
          {
            name: "keyword",
            type: "text",
            label: "Keyword",
            required: true,
          },
        ]
      : []),

    {
      name: "Tool",
      type: "select",
      label: "Tool",
      options: tools,
    },
    {
      name: "LLMs",
      type: "select",
      label: "LLMs",
      options: sortedLLMs,
      required: true,
    },
    {
      name: "Goal",
      type: "textarea",
      label: "Goal",
      rows: 5,
      cols: 50,
      required: true,
    },
    {
      name: "Backstory",
      type: "textarea",
      label: "Backstory",
      rows: 5,
      cols: 50,
      required: true,
    },
  ];
  let additionalFields: any = [];
  const toolValue = parseInt(formState.values.Tool);
  if (toolValue === 1) {
    additionalFields = [
      {
        name: "IMAPServer",
        type: "text",
        label: "IMAP server",
        required: true,
      },
      {
        name: "SMTPServer",
        type: "text",
        label: "SMTP server",
        required: true,
      },
      {
        name: "FromEmail",
        type: "email",
        label: "From email address",
        required: true,
      },
      {
        name: "EmailPassword",
        type: "password",
        label: "Email password",
        required: true,
      },
    ];
  } else if (toolValue === 2) {
    additionalFields = [
      {
        name: "IMAPServer",
        type: "text",
        label: "IMAP server",
        required: true,
      },
      {
        name: "SMTPServer",
        type: "text",
        label: "SMTP server",
        required: true,
      },
      {
        name: "RecipientEmailAddress",
        type: "text",
        label: "Recipient email address",
        required: true,
      },
      {
        name: "EmailPassword",
        type: "password",
        label: "Email password",
        required: true,
      },
    ];
  } else if (toolValue === 4) {
    additionalFields = [
      {
        name: "endPoint",
        type: "text",
        label: "End point",
        required: true,
      },
      {
        label: "Headers",
        isLabelOnly: true,
      },
      {
        name: "authType",
        type: "select",
        label: "Auth type",
        options: sortedAuthTypes,
        required: true,
      },
      ...(formState.values.authType === "bearer_token"
        ? [
            {
              name: "authToken",
              type: "text",
              label: "Auth token",
              required: true,
            },

            {
              name: "header",
              type: "custom",
              label: " Other header fields",
              required: true,
              component: GenericFields,
              props: { mode: "header" },
            },
          ]
        : []),

      ...(formState.values.authType === "basic_auth"
        ? [
            {
              name: "username",
              type: "text",
              label: "Username",
              required: true,
            },
            {
              name: "password",
              type: "text",
              label: "Password",
              required: true,
            },

            {
              name: "header",
              type: "custom",
              label: "Other header fields",
              required: true,
              component: GenericFields,
              props: {
                mode: "header",
              },
            },
          ]
        : []),
      {
        name: "method",
        type: "select",
        label: "Method",
        options: methods,
        required: true,
      },
      ...(["POST", "PUT"].includes(formState.values.method)
        ? [
            {
              name: "inputType",
              type: "text",
              label: "Input Type",
              value: "RAW",
              disabled: true,
              required: true,
            },
          ]
        : []),

      {
        name: "fields",
        type: "custom",
        label: "Fields",
        required: true,
        component: GenericFields,
        props: {
          mode: "fields",
        },
      },

      {
        name: "project",
        type: "text",
        label: "Project",
        required: true,
      },
    ];
  } else if (toolValue === 5) {
    additionalFields = [
      {
        name: "bucketName",
        type: "text",
        label: "Bucket name",
        required: true,
      },
      {
        name: "awsAccessKey",
        type: "text",
        label: "Aws access key",
        required: true,
      },
      {
        name: "awsSecretKey",
        type: "text",
        label: "Aws secret key",
        required: true,
      },
      {
        name: "regionName",
        type: "text",
        label: "Region name",
        required: true,
      },
    ];
  }
  // else if(toolValue == 6){
  //  additionalFields = [
  //   {
  //     name:'jd',
  //     label:'Jd',
  //     type:'file',
  //     required: true,
  //   }
  //  ]
  // }
  else {
    additionalFields = [];
  }
  //Client-side validations
  const validations = (values: Record<string, any>) => {
    const errors: Record<string, string> = {};

    if (!values.CrewName?.trim())
      errors.CrewName = "Crew name field is required";
    if (!values.AgentName?.trim())
      errors.AgentName = "Agent name field is required";
    if (!values.Role?.trim()) errors.Role = "Role field is required";
    // if (!values.LLMs?.trim()) errors.LLMs = "LLMs field  is required";
    if (!values.Goal?.trim()) errors.Goal = "Goal field is required";
    if (!values.Backstory?.trim())
      errors.Backstory = "Backstory field  is required";
    if (values.knowledgeHub && !values.keyword?.trim()) {
      errors.keyword =
        "Keyword field is required when Knowledge hub is enabled";
    }
    const toolValue = Number(values.Tool);

    if (toolValue === 1) {
      if (!values.IMAPServer?.trim()) {
        errors.IMAPServer =
          "IMAP Server is required. Please enter a valid IMAP server address.";
      } else if (!/^([a-zA-Z0-9.-]+)$/.test(values.IMAPServer.trim())) {
        errors.IMAPServer =
          "Invalid IMAP Server format. Please enter a valid domain or IP address.";
      }

      if (!values.SMTPServer?.trim()) {
        errors.SMTPServer =
          "SMTP Server field is required. Please enter a valid SMTP server address.";
      } else if (!/^([a-zA-Z0-9.-]+)$/.test(values.SMTPServer.trim())) {
        errors.SMTPServer =
          "Invalid SMTP  Server format. Please enter a valid domain or IP address.";
      }

      if (!values.FromEmail?.trim()) {
        errors.FromEmail = "From Email field is required";
      } else if (!validator.isEmail(values.FromEmail)) {
        errors.FromEmail = "Invalid email format";
      }

      if (!values.EmailPassword?.trim()) {
        errors.EmailPassword = "Password field  is required";
      }
    } else if (toolValue === 2) {
      if (!values.IMAPServer?.trim()) {
        errors.IMAPServer = "IMAP Server field is required";
      }

      if (!values.SMTPServer?.trim()) {
        errors.SMTPServer = "SMTP Server field is required";
      }

      if (!values.RecipientEmailAddress?.trim()) {
        errors.RecipientEmailAddress =
          "Recipient Email Address field is required";
      } else if (!validator.isEmail(values.RecipientEmailAddress)) {
        errors.RecipientEmailAddress = "Invalid email format";
      }
      if (!values.EmailPassword?.trim()) {
        errors.EmailPassword = "Password field  is required";
      }
    }
    if (toolValue === 4) {
      if (!values.endPoint?.trim()) {
        errors.endPoint = "End point field is required";
      }
      if (!values.authType?.trim()) {
        errors.authType = "Auth type field is required";
      }
      if (values.authType === "Bearer token" && !values.authToken?.trim()) {
        errors.authToken = "Auth token field  is required";
      }
      if (values.authType === "Basic Auth") {
        if (!values.username?.trim()) {
          errors.username = "Username field is required";
        }
        if (!values.password?.trim()) {
          errors.password = "Password  field is required";
        }
      }
      if (!values.header?.trim()) {
        errors.fields = "Key field is required";
      }
      if (!values.method?.trim()) {
        errors.method = "Method field is required";
      }
      if (
        ["POST", "PUT"].includes(values.method) &&
        !values.inputType?.trim()
      ) {
        errors.inputType = "Input Type field  is required";
      }
      if (!values.fields?.trim()) {
        errors.fields = "Field name field is required";
      }

      if (!values.project?.trim()) {
        errors.project = "Project field is required";
      }
    }
    if (toolValue === 5) {
      if (!values.bucketName.trim()) {
        errors.endPoint = "Bucket name field is required";
      }
      if (!values.awsAccessKey.trim()) {
        errors.endPoint = "Aws access key field is required";
      }
      if (!values.awsSecretKey.trim()) {
        errors.endPoint = "Aws secret key field is required";
      }
      if (!values.regionName.trim()) {
        errors.region_name = "Region name field is required";
      }
    }

    return errors;
  };

  const handleInputChange = useCallback(
    (
      e: React.ChangeEvent<
        HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
      >
    ) => {
      const target = e.target;
      const value =
        target instanceof HTMLInputElement && target.type === "checkbox"
          ? target.checked // Handle checkbox inputs separately
          : target.value; // Get the value from other input types
      const name = target.name; // Get the name attribute of the input

      setFormState((prev) => {
        const newValues = {
          ...prev.values,
          [name]: value,
        };

        if (name === "knowledgeHub") {
          setShowKeywordField(value as boolean); // Toggle the keyword field based on "knowledgeHub" checkbox
        }

        if (name === "method" && ["POST", "PUT"].includes(value as string)) {
          newValues.inputType = "RAW"; // Set inputType to "RAW" for specific HTTP methods
        }

        return {
          ...prev,
          values: newValues,
          clientErrors: { ...prev.clientErrors, [name]: "" },
          serverError: null,
        };
      });
    },
    []
  );
  //Function to handle agent data
  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault(); // Prevent default form submission behavior

      const errors = validations(formState.values); // Validate form fields
      if (Object.keys(errors).length === 0) {
        try {
          const toolValue = parseInt(formState.values.Tool); // Convert tool value to integer
          const submissionCrewId =
            crewId === 0 ? formState.values.CrewName : crewId; // Determine the crew ID for submission

          const fieldsArray = formState.values.fields
            ? formState.values.fields.split(",").map((field) => {
                const [key, value, defaultValue] = field.split(":");
                return {
                  name: key.trim(), // Trim whitespace from key
                  type: value ? value.toLowerCase().trim() : "text", // Default type to 'text'
                  default: defaultValue ? defaultValue.trim() : "",
                };
              })
            : [];

          const headersObject = formState.values.header
            ? formState.values.header.split(",").reduce((acc, field) => {
                const [key, value] = field.split(":");
                acc[key.trim()] = value.trim(); // Store headers as key-value pairs
                return acc;
              }, {} as Record<string, string>)
            : {};

          const formData = {
            project_id: localStorage.getItem("project_id"), // Get project ID from local storage
            ...(isEdit && { id: agentId }), // Include agent ID if editing
            agent_name: formState.values.AgentName, // Agent name field
            function: formState.values.Role, // Role field
            backstory: formState.values.Backstory, // Backstory field
            goal: formState.values.Goal, // Goal field
            finetune: formState.values.finetune, // Finetune setting

            keyword: formState.values.keyword, // Keyword field
            imap_server: "",
            smtp_server: "",
            from_email: "",
            to_email: "",
            password: "",
            knowledge_hub: formState.values.knowledgeHub, // Knowledge hub selection
            knowledge_keyword: formState.values.keyword, // Knowledge keyword field

            tools: toolValue, // Store selected tool value

            // Configure email-related fields based on tool selection
            ...(toolValue === 1 && {
              imap_server: formState.values.IMAPServer,
              smtp_server: formState.values.SMTPServer,
              from_email: formState.values.FromEmail,
              password: formState.values.EmailPassword,
            }),
            ...(toolValue === 2 && {
              imap_server: formState.values.IMAPServer,
              smtp_server: formState.values.SMTPServer,
              to_email: formState.values.RecipientEmailAddress,
              password: formState.values.EmailPassword,
            }),

            // Configure API-related fields for tool type 4
            ...(toolValue === 4 && {
              api_data: {
                fields: fieldsArray, // Processed API fields
                headers: headersObject, // Processed headers
                method: formState.values.method.toUpperCase(), // Convert method to uppercase
                project: formState.values.project, // Project field
                username: formState.values.username || "", // Username field
                password: formState.values.password || "", // Password field

                auth_type: formState.values.authType
                  .toLowerCase()
                  .replace(" ", "_"), // Normalize auth type format
                end_point: formState.values.endPoint, // API endpoint field
                auth_token: formState.values.authToken || "", // Authentication token
                input_type: "raw", // Set input type as 'raw'
              },
            }),

            // Configure S3-related fields for tool type 5
            ...(toolValue == 5 && {
              s3_details: {
                bucket_name: formState.values.bucketName || "", // S3 bucket name
                aws_access_key: formState.values.awsAccessKey || "", // AWS access key
                aws_secret_key: formState.values.awsSecretKey || "", // AWS secret key
                region_name: formState.values.regionName || "", // AWS region
              },
            }),

            llms: formState.values.LLMs, // Store LLMs selection
            crew: submissionCrewId, // Assign the correct crew ID
          };

          console.log(formData);
          const response = await service("/api/agent/", "post", formData); // Submit form data via API

          toast.success(
            `Agent ${isEdit ? "updated" : "created"} successfully!`,
            { autoClose: 2000 }
          ); // Show success toast message

          navigate(
            crewId == 0
              ? `/agents/${formState.values.CrewName}` // Navigate based on crew selection
              : `/agents/${id}`,
            {
              state: {
                crewName:
                  crewId == 0
                    ? crews.find(
                        (crew) =>
                          Number(crew.value) ===
                          Number(formState.values.CrewName)
                      )?.name || "crew_name"
                    : formState.values.CrewName,
              },
            }
          );
        } catch (err: any) {
          console.log(err);

          const functionError =
            err?.response?.data?.error?.non_field_errors || []; // Extract API error messages

          const errorMessage =
            Array.isArray(functionError) && functionError.length > 0
              ? functionError.join(", ") // Join multiple error messages
              : err.response?.data?.error ||
                "Something went wrong. Please try again."; // Default error message

          setFormState((prev) => ({ ...prev, serverError: errorMessage })); // Update server error state
        }
      } else {
        setFormState((prev) => ({ ...prev, clientErrors: errors })); // Update client errors state if validation fails
      }
    },
    [formState.values, isEdit, agentId, crewId, id, navigate] // Dependencies for useCallback
  );

  const handleCancel = () => navigate(`/agents/${id}`);
  //client errors in array format
  const clientErrorsArray = Object.entries(formState.clientErrors).reduce(
    (acc: string[], [field, error]) => {
      if (error) {
        acc.push(`${error}`);
      }
      return acc;
    },
    []
  );
  const handleEdit = () => {
    navigate(`/edit_agent/${id}/${agentId}`, { state: { crewName } });
  };
  //function to delete agents

  const handleDelete = async () => {
    setShowDelete(true);
  };

  const confrmDelete = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(`api/agent/delete/${agentId}/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success("Agent deleted successfully!", { autoClose: 2000 });
      navigate(`/edit_crew/${crewId}`, { state: { crewName } });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {loading ? (
        <Spinner />
      ) : agentDetail ? (
        <div>
            <AccessControl
              requiredPermissions={[
          {
            permission: "manage_agents",
            types: ["read"],
          },
        ]}
        renderNoAccess={ accessCheckLoading ? <Spinner/> :<AccessDenied />}
      >
          <SectionHeader back={true} title={"Agent details"} />
          <WindowHeightComponent className={""}>
            <div className="container-fluid">
              <div className="row p-3">
                <div className="col-md-12">
                  <div className="d-flex justify-content-end">
                  <AccessControl
                  requiredPermissions={[
                    {
                      permission: "build",
                      types: ["update"],
                    },
                  ]}
                  renderNoAccess={<></>}
                >
                    <button
                      title="Edit"
                      data-bs-toggle="tooltip"
                      className="me-2"
                      onClick={handleEdit}
                    >
                      <img src={EditIcon} alt="Edit" className="icon" />
                    </button>
                    </AccessControl>

                    <AccessControl
                  requiredPermissions={[
                    {
                      permission: "build",
                      types: ["delete"],
                    },
                  ]}
                  renderNoAccess={<></>}
                >
                    <button
                      title="Delete"
                      data-bs-toggle="tooltip"
                      onClick={handleDelete}
                    >
                      <img
                        src={DeleteIcon}
                        alt="Delete"
                        className="icon me-1"
                      />
                    </button>
                    </AccessControl>
                  </div>
                  <div className="Agent-details my-3 details-container">
                    <div className="detail-item">
                      <span className="field-label">Agent name:</span>
                      <span className="field-value">
                        {" "}
                        {formState.values.AgentName}
                      </span>
                    </div>
                    <div className="detail-item">
                      <span className="field-label">Agent ID:</span>
                      <span className="field-value"> {`00${agentId}`}</span>
                    </div>
                    <div className="detail-item">
                      <span className="field-label">Role: </span>
                      <span className="field-value">
                        {formState.values.Role}
                      </span>
                    </div>

                    { formState.values.Tool && <div className="detail-item">
                      <span className="field-label">Tools:</span>
                      <span className="field-value">
                        {formState.values.Tool}
                      </span>
                    </div>}

                    <div className="detail-item">
                      <span className="field-label">Used LLM: </span>
                      <span className="field-value">Claude 3.5 Sonnet</span>
                    </div>
                    <div className="detail-item">
                      <span className="field-label">Backstory: </span>
                      <span className="field-value">
                        {formState.values.Backstory}
                      </span>
                    </div>
                    <div className="detail-item">
                      <span className="field-label">Goal: </span>
                      <span className="field-value">
                        {" "}
                        {formState.values.Goal}
                      </span>
                    </div>
                    <div className="detail-item">
                      <span className="field-label">Created On:</span>
                      <span className="field-value">
                        {formState.values.createdAt}
                      </span>
                    </div>
                    <div className="detail-item">
                      <span className="field-label">Updated On: </span>
                      <span className="field-value">
                        {formState.values.updatedAt}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ConfirmDialog
              show={showDelete}
              onHide={() => setShowDelete(false)}
              onConfirm={confrmDelete}
              title="Confirm delete"
              body="Are you sure?"
              confirmText="Delete"
            />
          </WindowHeightComponent>
          </AccessControl>
          
        </div>
      ) : (
        <div>
            <AccessControl
             requiredPermissions={[
          {
            permission: "manage_agents",
            types:  isEdit ? ["read"]:["create"],
          },
        ]}
        renderNoAccess={ accessCheckLoading ? <Spinner/> :<AccessDenied />}
      >
          <SectionHeader
            back={true}
            title={isEdit ? "Edit agent" : "Create agent"}
          />
          <WindowHeightComponent className={""}>
            <div className="p-3">
              {formState.serverError && (
                <div className="alert alert-danger">
                  {formState.serverError}
                </div>
              )}
              {clientErrorsArray.length > 0 && (
                <div className="alert alert-danger">
                  <ul>
                    {clientErrorsArray.map((error, index) => (
                      <li key={index}>{error}</li>
                    ))}
                  </ul>
                </div>
              )}
              <CommonForm
                fields={fields}
                additionalFields={additionalFields}
                values={formState.values}
                onChange={handleInputChange}
                onSubmit={handleSubmit}
                onCancel={isEdit ? handleCancel : undefined}
                isEdit={isEdit}
              />
            </div>
          </WindowHeightComponent>
          </AccessControl>
        </div>
      )}
    </>
  );
};

export default AgentForm;
